export class SubscriptionFeature {
  constructor(feature = {}) {
    this.id = feature.id;
    this.title = feature.title;
  }
}
